import React from "react";
import { Head } from "@inertiajs/react";

const HeadSEO = ({ data }) => {
	return (
		<Head>
			{/* Basic SEO */}
			<title>{data?.title}</title>
			<meta name="description" content={data?.description} />
			<meta name="keywords" content={data?.keywords} />

			{/* Author */}
			<meta name="author" content="Valle Sabbia News" />

			{/* RSS Feed */}
			<link
				rel="alternate"
				type="application/rss+xml"
				title="RSS Feed di Valle Sabbia News"
				href="https://www.vallesabbianews.it/it.xml"
			/>

			{/* Sitemaps */}
			<link
				rel="sitemap"
				type="application/xml"
				title="Sitemap"
				href="https://www.vallesabbianews.it/it/sitemap.xml"
			/>
			<link
				rel="sitemap"
				type="application/xml"
				title="Sitemap Magazine e News"
				href="https://www.vallesabbianews.it/it/sitemap-magazine-news.xml"
			/>
			<link
				rel="sitemap"
				type="application/xml"
				title="Google News Sitemap"
				href="https://www.vallesabbianews.it/it/sitemap-google-news.xml"
			/>

			{/* Vari trovati su VSN */}
			<meta name="verify-v1" content="LY7JD1Gw58qu/hAUCrtHciMUTz6tW5b1FVcvdvEUGq8=" />
			<meta name="alexaVerifyID" content="tSSB7Oyg09WZrDda_5BQ9PvoNac" />
			<meta property="fb:pages" content="45373101826" />

			{/* Favicon */}
			<link rel="icon" href="/favicon/favicon.ico" />
			<link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
			<link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
			<link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
			<link rel="manifest" href="/favicon/site.webmanifest" />
			<link rel="mask-icon" href="/favicon/safari-pinned-tab.svg" color="#ff9900" />
			<meta name="msapplication-TileColor" content="#ff9900" />
			<meta name="theme-color" content="#ff9900" />

			{/* Apple-Specific */}
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta name="apple-mobile-web-app-status-bar-style" content="default" />
			<meta name="format-detection" content="telephone=no" />

			{/* Open Graph tags */}
			<meta property="og:url" content={data?.url} />
			<meta property="og:type" content="website" />
			<meta property="og:title" content={data?.title} />
			<meta property="og:description" content={data?.description} />
			<meta property="og:image" content={data?.image} />

			{/* Twitter Card tags */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:site" content="@vallesabbianews" />
			<meta name="twitter:title" content={data?.title} />
			<meta name="twitter:description" content={data?.description} />
			<meta name="twitter:image" content={data?.image} />

			{/* Dati strutturati */}
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: JSON.stringify(data?.structuredData) }}
			/>

			{/* CMP Consent */}
			<script async type="text/javascript" src="//clickiocmp.com/t/consent_234684.js"></script>

			<script>
				{`
                !function(){var M=document.createElement("div");M.className="azerion_privacy_privacy",M.style.position="fixed",M.style.padding="0",M.style.zIndex="9999",M.style.background="#f7f7f7",M.style.bottom="70px",M.style.left="0",M.style.boxSizing="border-box",M.style.fontFamily="Helvetica Neue,arial,sans-serif",M.style.fontWeight="400",M.style.fontSize="14px",M.style.lineHeight="14px",M.style["border-top-left-radius"]="3px",M.style["border-top-right-radius"]="3px",M.style["border-bottom-right-radius"]="3px",M.style["-webkit-border-top-left-radius"]="3px",M.style["-webkit-border-top-right-radius"]="3px",M.style["-webkit-border-bottom-right-radius"]="3px",M.style["-moz-border-radius-topleft"]="3px",M.style["-moz-border-radius-topright"]="3px",M.style["-moz-border-radius-bottomright"]="3px",M.style["writing-mode"]="tb-rl";var t=document.createElement("a");t.className="azerion_privacy_privacybutton",t.href="javascript:void(0)",t.onclick=function(){return void 0!==window.__lxG__consent__&&null!==window.__lxG__consent__.getState()&&window.__lxG__consent__.showConsent(),!1},t.style.padding="5px",t.style.display="block",t.style.textDecoration="none",t.style.color="#888",t.style.cursor="pointer",t.style.boxSizing="border-box",t.style.backgroundColor="transparent",M.appendChild(t);var w=document.createElement("img");w.className="azerion_privacy_privacyimg",w.src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTIgNTIiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MiA1MiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGc+PHBhdGggZD0iTTQzLjE5ODk3NDYsMTQuNTIwMDE5NWMtNi4wMzk5NzgtMS4zMzAwNzgxLTExLjUxMDAwOTgtNC41OTk5NzU2LTE1LjgwOTk5NzYtOS40NTk5NjA5bC0wLjY0MDAxNDYtMC43Mjk5ODA1ICAgQzI2LjU1ODk2LDQuMTE5OTk1MSwyNi4yODkwMDE1LDQsMjYuMDA4OTcyMiw0aC0wLjAxMDAwOThjLTAuMjc5OTY4MywwLTAuNTQ5OTg3OCwwLjEwOTk4NTQtMC43Mzk5OTAyLDAuMzIwMDY4NCAgIGwtMC45Nzk5ODA1LDEuMDc5OTU2MWMtNC4wOTAwMjY5LDQuNDg5OTkwMi05LjIyMDAzMjcsNy41ODk5NjU4LTE0Ljg0OTk3NjUsOC45Njk5NzA3TDguNzY4OTgxLDE0LjUzMDAyOTMgICBjLTAuNDI5OTkyNywwLjA5OTk3NTYtMC43NSwwLjQ4OTk5MDItMC43NjAwMDk4LDAuOTM5OTQxNEM3LjY0ODk4NTksMjkuNSwxNS45MjkwMTUyLDM5LjYwOTk4NTQsMTkuNTA4OTcyMiw0My4zMDAwNDg4ICAgYzIuMjUsMi4zMjk5NTYxLDUuMTMwMDA0OSw0LjY4OTk0MTQsNi40ODAwNDE1LDQuNjk5OTUxMmMwLjAwOTk0ODcsMCwwLjAwOTk0ODcsMCwwLjAwOTk0ODcsMCAgIGMwLjAxMDAwOTgsMCwwLjAyMDAxOTUsMCwwLjAyMDAxOTUsMGMxLjUyMDAxOTUtMC4wNDAwMzkxLDQuNDg5OTkwMi0yLjYwOTk4NTQsNi41NzAwMDczLTQuODAwMDQ4OCAgIGMzLjU1OTk5NzYtMy43NSwxMS43ODk5NzgtMTMuOTU5OTYwOSwxMS40MDAwMjQ0LTI3LjcyOTk4MDVDNDMuOTc5MDAzOSwxNS4wMTAwMDk4LDQzLjY0ODk4NjgsMTQuNjE5OTk1MSw0My4xOTg5NzQ2LDE0LjUyMDAxOTV6ICAgIE0yNy4yOTkwMTEyLDM2LjgzMDA3ODFDMjcuMTI4OTY3MywzNi45Mzk5NDE0LDI2LjkzODk2NDgsMzcsMjYuNzQ4OTYyNCwzN2MtMC4xNTk5NzMxLDAtMC4zMTk5NDYzLTAuMDQwMDM5MS0wLjQ2OTk3MDctMC4xMTk5OTUxICAgQzI1Ljk0ODk3NDYsMzYuNjk5OTUxMiwyNS43NDg5NjI0LDM2LjM1OTk4NTQsMjUuNzQ4OTYyNCwzNlYxNmMwLTAuMzM5OTY1OCwwLjE3MDA0MzktMC42NTk5MTIxLDAuNDYwMDIyLTAuODM5OTY1OCAgIGMwLjI4MDAyOTMtMC4xOTAwNjM1LDAuNjQwMDE0Ni0wLjIxMDA4MywwLjk1MDAxMjItMC4wNzk5NTYxbDEwLDQuNWMwLjM5OTk2MzQsMC4xNzk5MzE2LDAuNjMwMDA0OSwwLjU4OTk2NTgsMC41ODk5NjU4LDEuMDIwMDE5NSAgIEMzNy42OTg5NzQ2LDIxLjAxMDAwOTgsMzYuNTc4OTc5NSwzMC43NSwyNy4yOTkwMTEyLDM2LjgzMDA3ODF6Ii8+PC9nPjwvc3ZnPg==",w.style.width="14px",w.style.height="14px",w.style.borderStyle="none",w.style.boxSizing="border-box",t.appendChild(w),t.innerHTML+="Privacy";var D=0;window.onscroll=function(){0==D&&(D++,document.body.appendChild(M))}}();
                `}
			</script>

			{/* Google AdSense */}
			<script src="https://adv.rtbuzz.net/w123582.js" async></script>
			<script>{`window.RTBuzz=window.RTBuzz||{},window.RTBuzz.cmd=window.RTBuzz.cmd||[]`}</script>

			{/* Iubenda Consent */}
			<script type="text/javascript">
				{`var _iub = _iub || {}; _iub.cons_instructions = _iub.cons_instructions || []; _iub.cons_instructions.push(["init", {api_key: "MT9xivdUPm8Ca4DnCfg7VXU9AYsm5rDf"}]);`}
			</script>
			<script type="text/javascript" src="https://cdn.iubenda.com/cons/iubenda_cons.js" async></script>
		</Head>
	);
};

export default HeadSEO;
